module.exports = __webpack_public_path__ + "static/img/bg.4a6c2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yueyang/bg.png
// module id = SqsX
// module chunks = 1